const CART_KEY = 'heretic_cart';
export const CART_UPDATED_EVENT = 'heretic:cart-updated';

const emitCartUpdated = (cart) => {
  if (typeof window === 'undefined') return;
  try {
    window.dispatchEvent(
      new CustomEvent(CART_UPDATED_EVENT, {
        detail: { cart },
      })
    );
  } catch {
    return;
  }
};

export const getCartCount = (cartItems) =>
  (cartItems || []).reduce((sum, item) => sum + (Number(item.quantity) || 0), 0);

export const getCart = () => {
  if (typeof window === 'undefined') return [];

  try {
    const raw = window.localStorage.getItem(CART_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed)) return [];
    return parsed;
  } catch {
    return [];
  }
};

export const setCart = (items) => {
  if (typeof window === 'undefined') return;

  try {
    window.localStorage.setItem(CART_KEY, JSON.stringify(items));
    emitCartUpdated(items);
  } catch {
    return;
  }
};

export const addToCart = ({ slug, code, name, price, image }, quantity = 1) => {
  const qty = Number(quantity);
  if (!Number.isFinite(qty) || qty <= 0) return getCart();

  const cart = getCart();
  const index = cart.findIndex((item) => item.slug === slug);

  if (index >= 0) {
    const next = cart.slice();
    next[index] = {
      ...next[index],
      quantity: (next[index].quantity || 0) + qty,
    };
    setCart(next);
    return next;
  }

  const next = cart.concat([
    {
      slug,
      code,
      name,
      price,
      image,
      quantity: qty,
    },
  ]);

  setCart(next);
  return next;
};

export const removeFromCart = (slug) => {
  const cart = getCart();
  const next = cart.filter((item) => item.slug !== slug);
  setCart(next);
  return next;
};
